export default __webpack_public_path__ + "static/media/RightArrowBlue.ceafe998.svg";